
<template>
  <div id="content">
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <h1 v-translate>Přidat tématickou skupinu kanálů</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                    v-model="operatorIdComputed"
                    :options="operatorOptions"
                    :disabled="!allowSelectOperator"
                >
                </operator-select>
              </div>
            </div>
          </section>
            <thematic-group-basic-form
                :entity="entity"
                :is-editable="true"
                ref="streamprofileformref"
            ></thematic-group-basic-form>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     :class="['btn']"
                     @click.prevent.stop="createEntity()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import thematicGroups from "./mixins/thematicGroups";
import detailActions from "../../../components/mixins/detail-actions"
import ThematicGroupBasicForm from "./forms/ThematicGroupBasicForm.vue";

export default {
  name: "ThematicGroupNew",
  components: {ThematicGroupBasicForm},
  mixins: [detailActions, thematicGroups],
  data() {
    return {
      getSelectedOperatorAfterLoad: true,
      detailPageRouteName: "thematicGroupDetail",
    }
  },
  created(ThematicGroupService, OperatorService) {
    this.entityService = ThematicGroupService
    this.operatorService = OperatorService

    this.getOperatorsAndSetIdOperatorToEntity(true)
  },
  computed: {
    operatorIdComputed: {
      get() {
        return this.entity.id_operator
      },
      set(newValue) {
        return this.entity.id_operator = newValue
      }
    },
    allowSelectOperator(){
      return this.$_loggedUser_canChangeOperator && this.$_createActionAllowed;
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/thematicGroups/ThematicGroupNew.vue